module.exports = __webpack_public_path__ + "static/img/two_1196beijinligong.29c9c27.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/ggw_img/two_1196beijinligong.jpg
// module id = ADaP
// module chunks = 36